import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, UserIcon } from 'lucide-react';
interface ChatMessageProps {
  role: 'user' | 'ai';
  children: ReactNode;
}
export function ChatMessage({
  role,
  children
}: ChatMessageProps) {
  const isAi = role === 'ai';
  return <motion.div initial={{
    opacity: 0,
    y: 10,
    scale: 0.98
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.3,
    ease: 'easeOut'
  }} className={`flex w-full mb-6 ${isAi ? 'justify-start' : 'justify-end'}`} data-id="element-42">
      <div className={`flex max-w-[85%] ${isAi ? 'flex-row' : 'flex-row-reverse'}`} data-id="element-43">
        {/* Avatar */}
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mt-1 ${isAi ? 'bg-emerald-100 text-emerald-700 mr-3' : 'bg-slate-200 text-slate-600 ml-3'}`} data-id="element-44">
          {isAi ? <ShieldIcon className="w-4 h-4" data-id="element-45" /> : <UserIcon className="w-4 h-4" data-id="element-46" />}
        </div>

        {/* Message Bubble */}
        <div className={`flex flex-col ${isAi ? 'items-start' : 'items-end'}`} data-id="element-47">
          <div className={`px-4 py-3 rounded-2xl text-[15px] leading-relaxed ${isAi ? 'bg-white border border-slate-200 text-slate-800 shadow-sm rounded-tl-none' : 'bg-slate-800 text-white rounded-tr-none'}`} data-id="element-48">
            {children}
          </div>
          <span className="text-[11px] text-slate-400 mt-1 px-1" data-id="element-49">
            {isAi ? 'Franklin County AI' : 'You'}
          </span>
        </div>
      </div>
    </motion.div>;
}